import { useTheme } from 'styled-components'

import { Flex, FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { StIcon } from './Info.styled'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'

type Props = {
  icon: IconProp
  info: (string | undefined)[]
  color?: string
  bold?: boolean
  onClick?: () => void
}

const Info = ({ icon, info, color, bold, onClick }: Props) => {
  const theme = useTheme()

  return (
    <Flex alignItems='center' onClick={onClick} gap={theme.UI.Spacing.Space2}>
      <StIcon icon={icon} color={color || theme.Colors.Neutrals.Darkest} />
      <FlexColumn>
        {info.map((line, index) => {
          return (
            <Span
              key={index}
              type={bold ? 'BodyLargeBold' : 'BodyLargeRegular'}
              color={color || theme.Colors.Neutrals.Darker}
            >
              {line}
            </Span>
          )
        })}
      </FlexColumn>
    </Flex>
  )
}

export { Info }
